// Notificaciones del navegador para el operador (campana del panel).
// Best-effort: si el navegador no soporta Notification o el permiso no está
// concedido, las funciones no hacen nada.

export function notifySupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function notifyPermission(): NotificationPermission {
  return notifySupported() ? Notification.permission : 'denied';
}

export async function enableNotifications(): Promise<NotificationPermission> {
  if (!notifySupported()) return 'denied';
  if (Notification.permission === 'granted') return 'granted';
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function showNotification(title: string, body: string): void {
  if (!notifySupported() || Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title, { body, tag: 'chat-casino-msg', renotify: true } as NotificationOptions);
    n.onclick = () => {
      window.focus();
      n.close();
    };
  } catch {
    // ignore: algunos navegadores requieren SW para Notification; no es fatal
  }
}
